import { request } from "../../httpClient";

export const updateUserDataRequest = async (values) => {
  const res = await request({
    path: "user-data/set-data",
    method: "POST",
    body: values,
    requestType: null,
  });
  return res;
};
